import request from "@/lib/util/request";



// 会员消息
export const requestGetMessageList = (params: {"access-token": string,page?:string,limit?:string}) => request({
    endpoint: "/api/tiny-shop/v1/member/notify/index",
    method: "GET",
    params
});

// 最新消息
export const requestGetLatestMessage = (params: {"access-token": string}) => request({
  endpoint: "/api/tiny-shop/v1/member/notify/newest",
  method: "GET",
  params
});

// 消息详情
export const requestGetMessageDetail = (params: {"access-token": string,id: string}) => request({
  endpoint: "/api/tiny-shop/v1/member/notify/view",
  method: "GET",
  params: params
});

// 未读信息数量
export const requestGetMessageUnreadCount = (params: {"access-token": string}) => request({
  endpoint: "/api/tiny-shop/v1/member/notify/un-read-count",
  method: "GET",
  params: params
});


// 标记消息全部已读
export const requestGetMessageAllRead = (params: {"access-token": string}) => request({
  endpoint: "/api/tiny-shop/v1/member/notify/read-all",
  method: "GET",
  params: params
});
